<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "justificativa",
    "controlesDesativoados"
]);

const emits = defineEmits([
    "update:justificativa"
]);

//==================================================================//
//==================== Altera Data de Entrega ======================//
//==================================================================//

const alteraJustificativa = (justificativa) =>{

    emits('update:justificativa',{
        justificativa: justificativa
    });

}
</script>

<template>

  <v-card
        class="c-justificativa"
    >

        <v-card-title
            class="c-justificativa__titulo"
        >
        
            <h3>Observação para Revisão</h3>

        </v-card-title>

        <div
            class="c-justificativa__conteudo"
        >

            <v-textarea
                :value="props?.justificativa"
                class="c-campo"
                label="Observação"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                :disabled="props.controlesDesativados"
                @input="alteraJustificativa"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>

</style>